import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import polyPhone from "./modules/polyPhone";
import user from "./modules/user";
import tenant from "./modules/tenant";
import administrativeCenter from "./modules/administrativeCenter";
import teachingCenter from "./modules/teachingCenter";
import courseCenter from "./modules/courseCenter";
import pluginCenter from "./modules/pluginCenter";
import dataCenter from "./modules/dataCenter";
import transactionCenter from "./modules/transactionCenter";
import taskCenter from "./modules/TaskCenter";
import fuzhu from "./modules/fuzhu";
import projectCenter from "./modules/projectCenter";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        app,
        polyPhone,
        user,
        tenant,
        administrativeCenter,
        teachingCenter,
        courseCenter,
        dataCenter,
        pluginCenter,
        transactionCenter,
        taskCenter,
        fuzhu,
        projectCenter,
    },
});
